// extracted by mini-css-extract-plugin
export var label = "_8s-1";
export var reminder = "_8s-0";